
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    CollectionGenderType,
    CollectionGenderPayloadType,
} from "@/common/types/collection-gender";

export async function collectionGenderList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/gender/list${queryString}`
    );
}

export async function collectionGenderGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/gender/${item_id}/show`
    );
}

export async function collectionGenderCreate(
    collection_id: string,
    payload: CollectionGenderPayloadType
) {
    return await clientAxios.post(
        `collection/${collection_id}/gender/create`,
        payload
    );
}

export async function collectionGenderPatch(
    item_id: string,
    payload: Partial<CollectionGenderType>
) {
    return await clientAxios.patch(
        `collection/gender/${item_id}/patch`,
        { payload }
    );
}

export async function collectionGenderDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/gender/${item_id}/delete`,
    );
}
